import writeXlsxFile from "write-excel-file";
import moment from "moment";
import { toast } from "react-toastify";
// service
import { getSuperEmoji } from "../../../../../utils/services/dashboardSuperScreen";
// utils
import { parseFirestoreDate } from "../../../../../utils/helpers/files/formatDate";

// quantidade de registros buscados por requisição na exportação
const EXPORT_LIMIT = 999;

const listEmoji = [
  { code: "HAP", view: "😃" },
  { code: "PLA", view: "👏" },
  { code: "HEA", view: "❤️" },
  { code: "WOW", view: "😮" },
  { code: "LOL", view: "😂" },
];

// converte o código do emoji no emoji exibido. Código desconhecido aparece como
// veio (ex.: emoji novo adicionado no app) e código vazio como "-"
export function verifyEmoji(code) {
  if (!code) return "-";

  return listEmoji.find((e) => e.code === code)?.view ?? code;
}

// formata a data do clique para "DD/MM/AAAA - HH:mm" (aceita Timestamp do Firestore ou ISO)
export function formatDate(date) {
  const parsedDate = parseFirestoreDate(date);
  if (!parsedDate) return "";

  return moment(parsedDate).format("DD/MM/YYYY - HH:mm");
}

// atualiza a barra de progresso do WaitExport
function updateProgress(current, total) {
  const progressBar = document.querySelector(".export-progress");
  const percentageBar = document.querySelector(".export-percentage");
  const percentage = (current / total) * 100;

  if (progressBar) progressBar.style.width = `${percentage}%`;
  if (percentageBar) percentageBar.innerHTML = `${percentage.toFixed(0)}%`;
}

// busca todas as páginas de cliques nos emojis e gera o arquivo xlsx
export async function createXlsx({
  eventId,
  transmissionID,
  search,
  countData,
  mobileapps,
  setFinishExport,
  setExportInProgress,
}) {
  const schema = [
    {
      column: "ID do Participante",
      type: String,
      value: (emoji) => emoji.userId,
    },
    {
      column: "Nome do Participante",
      type: String,
      value: (emoji) => emoji.name,
    },
    {
      column: "Emoji",
      type: String,
      value: (emoji) => verifyEmoji(emoji.emoji_code),
    },
    {
      column: "Data e Hora",
      type: String,
      value: (emoji) => formatDate(emoji.date),
    },
  ];

  try {
    const allData = [];
    const numberOfRequisitions = Math.ceil(countData / EXPORT_LIMIT);

    for (let page = 1; page <= numberOfRequisitions; page += 1) {
      const res = await getSuperEmoji({
        eventId,
        transmissionID,
        pageSize: EXPORT_LIMIT,
        offset: page - 1,
        search,
        mobileapps,
      });

      if (!res?.success) {
        throw new Error("Erro ao buscar cliques nos emojis.");
      }

      allData.push(...res.data);
      updateProgress(page, numberOfRequisitions);
    }

    if (allData.length > 0) {
      await writeXlsxFile(allData, {
        schema,
        fileName: "SuperEmojis.xlsx",
      });
    }

    setTimeout(() => {
      setFinishExport(true);
    }, 1000);
  } catch (error) {
    setExportInProgress(false);
    toast.error("Erro ao exportar cliques nos emojis.");
  }
}
